import axios from "axios";
import { T, APIS } from "../../Constants";

type BTVSites = T.API.ToAxios<T.API.Utils.DataSource.BTVSites>;
type BTVDocFiles = T.API.ToAxios<T.API.Utils.DataSource.BTVDocFiles>;
type ExtElements = T.API.ToAxios<T.API.Utils.DataSource.ExtElements>;
type GetDatasources = T.API.ToAxios<T.API.Utils.DataSource.GetDatasources>;
type SaveDataSource = T.API.ToAxios<T.API.Utils.DataSource.SaveDataSource>;
type DeleteDataSource = T.API.ToAxios<T.API.Utils.DataSource.DeleteDataSource>;
type RefreshDataSource = T.API.ToAxios<T.API.Utils.DataSource.RefreshDataSource>;

/** Load sites from the BTV API */
export const loadBTVSites: BTVSites = params => axios.post(APIS.DATASOURCE_API + "btv/sites", params);
/** Load the context elements, and pre-map them to the BTV appliances */
export const loadExtElements: ExtElements = datasource => axios.post(APIS.DATASOURCE_API + "ext/elements", { datasource });
/** Update or create a datasource */
export const saveDataSource: SaveDataSource = datasource => axios.post(APIS.DATASOURCE_API + "save", datasource);
/** Get the datasources on an item, or on the item's site */
export const getDatasources: GetDatasources = item_id => axios.post(APIS.DATASOURCE_API + "get", { id: item_id });
/** Get the documents files for a given appliance */
export const getBTVDocFiles: BTVDocFiles = params => axios.post(APIS.DATASOURCE_API + "btv/doc", params);
/** Refresh the data for a datasource */
export const refreshDataSource: RefreshDataSource = datasource => axios.get(APIS.DATASOURCE_API + "refresh", { params: { id: datasource } });
/** Delete a datasource */
export const deleteDataSource: DeleteDataSource = datasource => axios.delete(APIS.DATASOURCE_API + "delete", { params: { id: datasource } });